import { useMemo } from "react";

import { TextCell } from "@similarweb/pro-logic-components";

import { getItemPlusNValue } from "app/pages/sales-intelligence/common-components/table-cells";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import type {
    COLUMN_AD_NETWORKS_ADDED_NAME,
    COLUMN_AD_NETWORKS_REMOVED_NAME } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import {
    COLUMN_NEWS_NAME,
} from "app/pages/sales-intelligence/sub-modules/signals/constants";
import { AD_NETWORK_SUBTYPE_BY_COLUMN_NAME } from "app/pages/sales-intelligence/sub-modules/signals/constants/tooltip";
import type {
    IUseTrackedSignalTooltipResponse } from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import {
    useTrackedSignalTooltip,
} from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";

import { SignalAdNetworksTooltipContainer } from "../SignalAdNetworksTooltipContainer/SignalAdNetworksTooltipContainer";

import { StyledCenteredBaseCell } from "./styles";

interface ISignalAdNetworkCellContainerProps<V extends LeadsSearchRow> {
    field: typeof COLUMN_AD_NETWORKS_ADDED_NAME | typeof COLUMN_AD_NETWORKS_REMOVED_NAME;
    record: V;
}

export const SignalAdNetworkCellContainer = <V extends LeadsSearchRow>({
    record,
    field,
}: ISignalAdNetworkCellContainerProps<V>) => {
    const value = (record[field] ?? []);
    const names = useMemo(() => {
        return value.map(({ ad_network }) => ad_network);
    }, [value]);

    const cellText = getItemPlusNValue(names);

    const { onTrackedTooltipClick }: IUseTrackedSignalTooltipResponse = useTrackedSignalTooltip({
        field: COLUMN_NEWS_NAME,
        value: value.length,
    });
    return (
        <SignalAdNetworksTooltipContainer
            value={value}
            field={field}
            onViewAll={onTrackedTooltipClick}
            signalSubType={AD_NETWORK_SUBTYPE_BY_COLUMN_NAME[field]}
            row={record}
        >
            <StyledCenteredBaseCell>
                <TextCell dataAutomation="ad-network-cell">{cellText}</TextCell>
            </StyledCenteredBaseCell>
        </SignalAdNetworksTooltipContainer>
    );
};
